module.exports = __webpack_public_path__ + "plaque-nomogram-female.2b51a35fa91c7419b80bf0a8fb1cd7d5.png";